/**
 * Your Business Header - Server Component (Static)
 *
 * Renders immediately on server - no data fetching required.
 * This uses Next.js 16 PPR to show static content first, then stream dynamic data.
 */

import { Building2 } from 'lucide-react';

export function YourBusinessHeader() {
  return (
    <div className="flex items-center space-x-3">
      <div
        className="w-10 h-10 rounded-xl flex items-center justify-center"
        style={{ backgroundColor: 'var(--primary-color, #22577A)15' }}
      >
        <Building2 size={20} style={{ color: 'var(--primary-color, #22577A)' }} />
      </div>
      <div>
        <h1 className="text-2xl font-bold text-text-primary">Your Business</h1>
        <p className="text-sm text-text-secondary">Configure your business information, hours and after-hours responses</p>
      </div>
    </div>
  );
}
